import type { ReportBlock } from '@/lib/types/report'
import type {
  ActivityWithExchanges,
  ForegroundTree,
} from '@/lib/types/project-graph'
import {
  StaticAttributionSankey,
  type HotspotWithAttribution,
  type ForegroundBiosphereExchange,
} from '@/components/report/blocks/StaticAttributionSankey'
import { FigureFrame } from '@/components/report/primitives/FigureFrame'

// Raw (snake_case) attribution payload carried on the report block's `data`.
interface AttributionSankeyData {
  hotspots?: HotspotWithAttribution[]
  foreground_tree?: ForegroundTree
  total_score?: number
  unit?: string
  method_name?: string
  project_name?: string
  activities?: ActivityWithExchanges[]
  foreground_biosphere_exchanges?: ForegroundBiosphereExchange[]
}

export function AttributionSankeyBlock({ block }: { block: ReportBlock }) {
  const d = block.data as AttributionSankeyData
  if (!Array.isArray(d.hotspots) || !d.foreground_tree || typeof d.total_score !== 'number') {
    return <div className="rounded border border-warning/40 bg-warning-muted p-3 text-sm text-warning-foreground">hotspot attribution data unavailable for this report</div>
  }
  return (
    <FigureFrame
      caption="Attribution of the total impact across the foreground system, from unit processes to elementary flows."
      source="calculate_hotspots_custom attribution"
    >
      <StaticAttributionSankey
        hotspots={d.hotspots}
        foregroundTree={d.foreground_tree}
        totalScore={d.total_score}
        totalUnit={d.unit}
        methodName={d.method_name}
        projectName={d.project_name}
        activities={d.activities}
        foregroundBiosphereExchanges={d.foreground_biosphere_exchanges}
      />
    </FigureFrame>
  )
}
